module.exports = __webpack_public_path__ + "img/CG.af5e7424.svg";